import React from "react";

import { ButtonStandard, Text, toast } from "@performyard/py-components";

import ContentModal from "../../../../../../components/Modal/Templates/ContentModal";
import Spacer from "../../../../../../components/Spacer";

import { useSetters as useParticipantSelectionSetters } from "../../pages/SurveyParticipants/store/store";

import { SURVEY_DETAILS_MODALS } from "../../store/model";
import { useModal, useSetters } from "../../store/store";

import { useUpdateSurvey } from "../../../../../../api/hooks";

export const SelectAllEmployeesModal = ({ surveyId }: { surveyId: string }) => {
	const setters = useSetters();
	const participantSelectionSetters = useParticipantSelectionSetters();
	const modal = useModal();
	const { mutate: removeSelections } = useUpdateSurvey(surveyId, {
		onSuccess: () => {
			participantSelectionSetters.setSurveyAccess("all-employees");
			participantSelectionSetters.setEditParticipants(false);
			participantSelectionSetters.setTemporarySelectionObjectId(null);
			toast.success("Your changes have been saved");
			setters.setModal(null);
		},
	});
	const handleRemoveSelections = () => {
		removeSelections({
			participantSelection: {
				enabled: false,
				selection_object_id: null,
			},
		});
	};
	return (
		<ContentModal
			size="large"
			isOpen={modal === SURVEY_DETAILS_MODALS.SELECT_ALL_EMPLOYEES_MODAL}
			handleClose={() => setters.setModal(null)}
		>
			<div className="flex w-full flex-col items-center">
				<Text size="sub-heading" weight="semi-bold">
					<div className="text-center">
						Changing Survey Access will remove all active selections and cannot be undone.
					</div>
				</Text>
				<Spacer height={2} />
				<div className="flex justify-center gap-2">
					<span className="w-[90px]">
						<ButtonStandard onClick={() => setters.setModal(null)} size="large" color="primary">
							Cancel
						</ButtonStandard>
					</span>
					<span className="w-[125px]">
						<ButtonStandard onClick={handleRemoveSelections} size="large" color="green">
							Yes, Continue
						</ButtonStandard>
					</span>
				</div>
			</div>
		</ContentModal>
	);
};

export const NoParticipantsSelectedModal = () => {
	const setters = useSetters();
	const modal = useModal();
	return (
		<ContentModal
			size="small"
			isOpen={modal === SURVEY_DETAILS_MODALS.NO_PARTICIPANTS_SELECTED_MODAL}
			handleClose={() => setters.setModal(null)}
		>
			<div className="flex w-full flex-col items-center">
				<Text size="sub-heading" weight="semi-bold">
					<div className="text-center">
						You do not have participants selected. Please navigate to the participants tab to grant survey
						access.
					</div>
				</Text>
				<Spacer height={2} />
				<div className="flex justify-center gap-2">
					<span className="w-[90px]">
						<ButtonStandard onClick={() => setters.setModal(null)} size="large" color="primary">
							Close
						</ButtonStandard>
					</span>
				</div>
			</div>
		</ContentModal>
	);
};
